/* Anchor the search dialog near the top of the viewport rather than
 * vertically centered. Without overriding the base dialog's enter
 * keyframe, the 200ms entrance animation tweens via the centered
 * `translate(-50%, -50%)` transform and only snaps to the override
 * `translateX(-50%)` once the animation ends — producing a vertical
 * jank as the dialog drops into place. The keyframe below matches the
 * steady-state transform so the entrance is smooth from frame one. */
@keyframes searchDialogEnter {
  from {
    opacity: 0;
    transform: translateX(-50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}

.dialog {
  top: 32px;
  transform: translateX(-50%);
  margin: 0;
  min-height: 200px;
  animation: searchDialogEnter 200ms ease-out;
}

.dialogContent {
  display: flex;
  flex-direction: column;
}
